import { MessageCircle } from 'lucide-react';
import { companyInfo } from '../data/pricing';
import { trackRewiringEvents } from '../utils/tracking';

export const WhatsAppButton = ({ message = "Hi Crescent Electrical, I'd like a quote for electrical work at my property.", source = "floating_button" }) => {
  const handleClick = () => {
    trackRewiringEvents.whatsappClick(source);
  };

  return (
    <a
      href={`https://wa.me/${companyInfo.whatsapp}?text=${encodeURIComponent(message)}`}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      className="fixed bottom-24 md:bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-2xl hover:scale-110 transition-all duration-200 group"
      data-testid="whatsapp-floating-button"
      aria-label="Contact us on WhatsApp"
    >
      <MessageCircle className="h-6 w-6" />
      <span className="absolute -top-1 -right-1 w-3 h-3 bg-green-400 rounded-full animate-pulse" />
    </a>
  );
};
